import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kycstyle.css';
import moment from "moment";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";
import { v4 as uuidv4 } from 'uuid';
import biometry from "./biometry";
import { store } from "../../redux/store";
import XMLParser from 'react-xml-parser';
import tokenErrorHandler from "../tokenErrorHandler";
import { setBiometricDtaCaptureStatus, setMerchantOnboardStatus, setOnboardActiveRoId, setOnboardActiveRoIdMap, setOnboardResponse } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
const httpClient = axios.create();
class KycProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            personalInfo: '',
            fullName: '',
            mobile: '',
            panNo: '',
            aadhaar: '',
            aadhaarErr: '',
            // roId: '123456789123',
            roId: '',
            sessionId: '',
            email: '',
            otpErrMsg: '',
            verifyErrMsg: '',
            verifyOtpEnable: 'hidden',
            deviceConnectStatus: 'LOADING',
            progress: '',
            merchantOnBoarStatus: '',
            nameErr: '',
            merchantOnBoardErr: ''

        }
    }


    componentDidMount() {
        // store.dispatch(setOnboardActiveRoId(''));
        store.dispatch(setBiometricDtaCaptureStatus(''));

        // this.getSessionDetails();
        this.getProfile();


    }

    getSessionDetails = () => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        };

        httpClient.get('/api/v1/retailer/onboard/session/'
            // + this.props.registerRetailerResponse.sessionId
            + '6defd38d-57f2-41f7-9ed8-cf11c7d64cbc'
            , { headers }
        ).then((response) => {
            console.log('session Id retailer response' + JSON.stringify(response.data));
            if (response.data.personalInfo != null) {
                this.setState({
                    fullName: response.data.personalInfo.fname + ' ' + response.data.personalInfo.lname,
                    mobile: response.data.personalInfo.mobile
                })
            }




        }).catch(error => {
            alert(error.message);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }


        });
    }

    getProfile = () => {

        this.setState({
            verifyErrMsg: ''
        })
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        };

        httpClient.get('/api/v1/retailer/get/'
            + this.props.agentInfo.id
            // +'315093322150151'
            , { headers }
        ).then((response) => {
            console.log('get Profile Response' + JSON.stringify(response.data));
            if (response.data != null) {
                this.setState({
                    // roId: response.data.id,
                    sessionId: response.data.sessionId,
                    email: response.data.personalInfo.email
                })
                if (response.data.personalInfo != null) {
                    this.setState({
                        fullName: response.data.personalInfo.fname + ' ' + response.data.personalInfo.lname,
                        mobile: response.data.personalInfo.mobile
                    })
                }
                var docs = [];
                if (response.data != null) {
                    if (response.data.kycInfo != null) {
                        docs = response.data.kycInfo.docs;
                    }
                }
                if (docs.length > 0) {

                    this.setState({
                        docs: docs
                    })
                    docs.map(doc => {
                        if (doc.type == 'PAN_CARD') {
                            this.setState({
                                panNo: doc.id,
                            })
                        }

                    })

                }

                // if (response.data.id != null) {
                //     this.verifyNerchantOnbaord(this.props.agentInfo.id)
                // }
            }
        }).catch(error => {
            // this.setState({
            //     verifyErrMsg: 'Something went wrong!'
            // })
            // alert(error.message);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {
                this.setState({
                    fullName: this.props.agentInfo.id,
                    mobile: this.props.agentInfo.mobile,
                    email: this.props.agentInfo.email,
                })
            }

        });
    }
    componentWillUnmount() {
    }

    validateName() {
        // var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
        var regName = /^[a-zA-Z ]*$/;
        var name = this.state.fullName;

        var regexp = /\b[^\d\s]+\b/g;
        var count = 0;
        while (regexp.exec(name)) {
            ++count;
        }

        var nameArray = name.split(" ");
        for (let i = 0; i < nameArray.length; i++) {
            if (nameArray[i].length <= 2) {
                alert('Each word in name should contains more than two characters and one space between them');
                return false;
            }
        }

        if (!regName.test(name)) {
            alert('Name should contains alphabets only');
            return false;
        } else if (count < 2) {
            alert('Please enter at least two words');
            return false;
        } else {
            return true;
        }
    }



    aadhharValidation = () => {
        if (this.state.aadhaar != '' &&
            (this.state.aadhaar.length == 12 || this.state.aadhaar.length == 16)) {
            return true;
        } else {
            this.setState({
                aadhaarErr: 'Please enter correct aadhaar/VID'
            })
            return false;
        }
    }

    whiteLabelEnquiry = (msg, roId) => {


        this.setState({
            merchantOnBoardErr: ''
        })

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get('/api/v1/paysprint/merchantOnboard/whitelabel/enquiry/' + roId,
            { headers }
        ).then((response) => {
            console.log('/whitelabel/enquiry/ response' + JSON.stringify(response.data));


            if (response.data.bankApprovedStatus == "Accepted") {
                this.setState({
                    merchantOnBoardErr: 'Merchant already onboarded.Please re-login.'
                })


            } else if (response.data.bankApprovedStatus == 'Pending') {
                if (msg.includes('Merchant already onboarded on  Pipe.')) {
                    this.setState({
                        merchantOnBoardErr: 'Merchant already onboarded.Bank approval status is pending'
                    })
                } else {
                    this.setState({
                        merchantOnBoardErr: msg
                    })
                }
            } else {
                this.setState({
                    merchantOnBoardErr: msg
                })
            }

        }).catch(error => {
            this.setState({
                progress: 'completed',
                merchantOnBoardErr: msg
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }

        });
    }

    merchantOnboard = (event) => {
        event.preventDefault();
        this.setState({
            merchantOnBoardErr: ''
        })

        if (this.aadhharValidation() == true
            // && this.validateName() == true
        ) {

            this.setState({
                progress: 'loading'
            })

            var kycSession = {
                mobile: this.state.mobile,
                roId: this.props.agentInfo.id,
                sessionId: uuidv4(),
                email: this.state.email,
            }
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),
                traceId: uuidv4(),
            }

            var request = {
                header: header,
                merchantOnboardLog: kycSession
            }

            httpClient.post('/api/v1/paysprint/merchantOnboard/onboardUrl', request,
                { headers }
            ).then((response) => {
                console.log('onboard Response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    this.setState({
                        progress: 'completed'
                    })
                    store.dispatch(setOnboardActiveRoId(this.props.roId));
                    store.dispatch(setOnboardResponse(response.data));

                    var valMap = this.props.roId + ':0';

                    store.dispatch(setOnboardActiveRoIdMap(valMap));

                    if (response.data.redirectUrl != null) {
                        var myWindow = window.open(response.data.redirectUrl);
                    } else {
                        this.whiteLabelEnquiry(response.data.response.msg, this.props.agentInfo.id);
                    }

                } else {
                    if (response.data.response.displayMsg.includes("Merchant Id already registered")) {
                        this.setState({
                            progress: 'completed',
                            merchantOnBoardErr: "Merchant Id already registered"
                        })
                    } else {
                        this.setState({
                            progress: 'completed',
                            merchantOnBoardErr: response.data.response.displayMsg
                        })
                    }

                }

            }).catch(error => {
                this.setState({
                    progress: 'completed',
                    merchantOnBoardErr: 'Something went wrong'
                })
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }

            });
        }
    }

    verifyNerchantOnbaord = (roId) => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get('/api/v1/paysprint/connector/kyc/whitelabel/enquiry/' +
            roId,
            { headers }
        ).then((response) => {
            console.log('merchant onbaord  enquiry Response' + JSON.stringify(response.data));
            if (response.data.merchantOnBoarStatus == 'completed') {
                store.dispatch(setMerchantOnboardStatus('completed'));
            } else {
                store.dispatch(setMerchantOnboardStatus('not-completed'));
            }
        }).catch(error => {
            store.dispatch(setMerchantOnboardStatus('not-completed'));
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }

        });

    }



    enterAadhaar = (event) => {
        this.setState({
            aadhaarErr: '',
            aadhaar: event.target.value
        })
    }

    changeName = (event) => {
        this.setState({
            nameErr: '',
            fullName: event.target.value
        })
    }


    render() {
        // alert(JSON.stringify(this.props.agentInfo))

        return (

            <div>
                <HeaderCommon />
                <Menu />

                <div class="mid-contant1">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="head1">
                                    <h2>KYC Process</h2>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="kycform">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                         
                                                <div class="row">
                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="firsname" placeholder="Enter name"
                                                                value={this.state.fullName}
                                                                onChange={this.changeName}
                                                                readOnly
                                                            />
                                                            <label for="firsname">Full Name</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="mobile" placeholder="Enter mobile no." value={this.state.mobile}
                                                                readOnly
                                                            />
                                                            <label for="mobile">Mobile number</label>
                                                        </div>
                                                    </div>
                                                    {this.props.agentInfo.status != 'BANK_KYC_COMPLETE' &&
                                                        <div class="col-12 col-md-6">
                                                            <div class="form-floating">
                                                                <input type="number" class="form-control" id="lastname" placeholder="Enter Aadhaar" value={this.state.aadhaar}
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
                                                                    onChange={this.enterAadhaar} />
                                                                <label for="lastname">Aadhaar Number / VID</label>
                                                            </div>
                                                            {this.state.aadhaarErr != '' &&
                                                                <div class='valid-error'>
                                                                    {this.state.aadhaarErr}</div>}
                                                        </div>
                                                    }

                                                    {this.state.panNo != '' &&
                                                        < div class="col-12 col-md-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="pan" placeholder="Enter PAN" value={this.state.panNo}
                                                                    readOnly
                                                                />
                                                                <label for="pan">PAN Number</label>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            {this.state.verifyErrMsg != '' &&
                                                                <div class='valid-error'>
                                                                    {this.state.verifyErrMsg}</div>}
                                                        </div>

                                                    </div>

                                                    <div class="col-12 mt-4">
                                                        <div class="form-check">

                                                            {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&
                                                                <label class="form-check-label tnc" for="tnc">Successfully Registered! </label>
                                                                //  :
                                                                // <label class="form-check-label tnc" for="tnc">By registering, you confirm that you accept our <a href="#">terms and conditions</a></label>
                                                            }
                                                        </div>
                                                    </div>
                                                    {this.props.agentInfo.status != 'BANK_KYC_COMPLETE' &&
                                                        <div class="col-12">
                                                            <button type="button" class="btn btn-primary" id="proceedAeps" onClick={this.merchantOnboard}
                                                                disabled={this.state.progress == 'loading' ? true : false}
                                                            >Proceed</button>

                                                            {this.state.merchantOnBoardErr != '' &&
                                                                <div class='valid-error'>
                                                                    {this.state.merchantOnBoardErr}
                                                                </div>}
                                                        </div>
                                                    }

                                                </div>
                                           
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block">
                                            <div class="rightbanner"><img src="images/register.png" alt="Oxigen" class="img-fluid" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

                <FooterComponet />

            </div >

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, callBackUrl },
        retailerKycReduce: { registerRetailerResponse, personalInfo, roResponse, kycBiometricDtaCaptureStatus, kycBiometricData, roId, merchantOnboardStatus } }

) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole,
    clientRequesterId, callBackUrl,
    registerRetailerResponse, personalInfo, roResponse, kycBiometricDtaCaptureStatus, kycBiometricData,
    roId, merchantOnboardStatus
});

export default connect(mapStateToProps, null)(KycProcess);
